var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Live = OCS.Viewer.Live || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};

//TODO: Continue developing on data retrieval system and setup subscriptions

OCS.Viewer.Functions.define_data_manager = function () {
    OCS.Viewer.Classes.DataManager = new Class({
        Extends: OCS.Viewer.Classes.SingletonManager,
        class_name: "DataManager",
        bound_methods: {},
        manager_name: 'DataManager',
        stored_request: {},
        event_to_request: null,
        dataworker_activation_timeout: null,
        request_manager: null,
        options: {
            class_name: "OCS.Viewer.DataManager",
            manager_name: 'data_manager',
            polygon_amp_prefix: "poly_",
            webworker_radar_parser: true,
            max_channel_entries: 20,
            actively_retrieve_data: true,
            store_locally: true // Allows data to be stored on local and session storage on the user computer

        },
        init: function (op) {
            this.setOptions(op);
            this.bound_methods.on_data_expiration = this.on_data_expiration.bind(this);
            this.request_manager = OCS.Functions.get_ajax_manager(OCS.Viewer.Config.ajaxManager);
            this.event_to_request = new OCS.Classes.ListManager({debug: this.options.debug});
            // Register the events
            this.initialize_events();

            // Initialize Web Worker
            this.dataworker_activation_timeout = setTimeout(this.start_data_worker.bind(this), OCS.Viewer.Config.dataworker_start_time);
            if (OCS.Viewer.Functions.use_workers()) {
                OCS.Viewer.Functions.get_event_manager().subscribe({event_name: OCS.Viewer.Config.events.DATAWORKER_ONLINE, callback: this.on_dataworker_online.bind(this), fire_immediately: true, once: true});
            }

        },
        initialize_events: function () {
            // Object Events
            this.addEvent('process_data_request', this.on_process_data_request.bind(this));

            var sm = OCS.Viewer.Functions.get_storage_manager();
            sm.addEvent(sm.options.data_expiration_event, this.bound_methods.on_data_expiration);


        },
        /*
         * Event Listeners
         */
        on_data_request_completed: function (request) {
            var request_id = request.get_request_id();
            this.stored_request[request_id] = null;
            delete this.stored_request[request_id];
        },
        on_new_data_arrival: function (data) {

        },
        on_dataworker_message: function (event) {
            if (event.cmd) {
                switch (event.cmd) {
                    case 'data':
                        if (event.options.entry.json.dataset !== "edu.ou.ocs.lightning" && event.options.entry.json.dataset !== "lightning" && event.options.entry.json.dataset !== "edu.ou.ocs.advisories") {
                            this.new_data_arrival(OCS.Functions.define_data_obj(event.options));
                        }
                        break;
                }
            }
        },
        on_dataworker_online: function () {

        },
        on_process_data_request: function (request) {
            var i, result;
            if (!request || !request.is_valid()) {
                // request is not valid so end processing
                return;
            }

            if (!request.request_processed) {
                this.stored_request[request.get_request_id()] = request;
                request.addEvent('complete', this.on_data_request_completed.bind(this));
                request.addEvent('timestamp_added', this.on_process_data_request.bind(this));
                request.addEvent('subscribe', this.on_subscription_update.bind(this));
                request.addEvent('unsubscribe', this.on_subscription_update.bind(this));
                request.addEvent('process_again', this.on_process_data_request.bind(this));

                // Is this a subscription
                if (request.get_subscription() && this.options.actively_retrieve_data) {
                    this.send_data_worker_message({'cmd': 'subscribe_init', 'options': request.metadata()});
                }
                request.request_processed = true;
            }

            if (request.is_date_request && request.is_date_request()) {
                this.make_dates_request(request);
                return;
            }

            // Is there a call for some initial data?
            var timestamp_array = request.get_initial_req_timestamp_array();
            result = this.is_data_accumulated(request);
            if (result.result) {
                // We have all the requested data
                this.get_accumulated_data(request);
            } else {
                var req_meta = request.get_metadata();
                if (timestamp_array.length) {
                    if (result.found_times.length) {
                        this.get_accumulated_data(request);
                    }
                    if (result.not_found_times.length) {
                        // So we are missing some data, got to go retrieve it
                        var data_key;
                        for (i = 0; i < result.not_found_times.length; i++) {
                            data_key = this.make_data_key({'dataset': req_meta.dataset, 'grid': req_meta.grid, variables: req_meta.variables, timestamp: result.not_found_times[i]});
                            if (!this.is_requested(data_key)) {
                                this.make_data_request(data_key);
                            }
                            this.event_to_request.register(data_key, request);
                        }
                    }
                } else {
                    if (request.has_url()) {
                        this.make_data_request(request.metadata());
                        return;
                    }
                }
            }

        },
        on_subscription_update: function (req) {
            var sub_state = req.get_subscription();
            if (sub_state) {
                this.send_data_worker_message({'cmd': 'subscribe_init', 'options': req.metadata()});
            } else {
                this.send_data_worker_message({'cmd': 'subscribe_terminate', 'options': req.metadata()});
            }
        },
        /*
         * Event Fires
         */
        new_data_arrival: function (data) {
            var json = data.json();
            var info = data.get_info();
            var j, req, data_key;
            if (data.was_successful() && data.has_payload()) {
                if (!json.dates) {
                    data_key = data.get_data_key();
                    var requested = this.is_requested(data_key);
                    if (requested) {
                        var reqs = this.event_to_request.get_list_key_elements(requested);
                        if (reqs.length) {
                            for (j = 0; j < reqs.length; j++) {
                                req = reqs[j];
                                if (req && req.fireEvent) {
                                    req = reqs[j].fireEvent('new_data_arrival', data);
                                }
                            }
                        }
                        this.event_to_request.make_list_key_inactive(requested);
                    } else {
                        // Is this data we have not requested?


                    }
                    var storage_data_key = this.store_new_data(data);
                    if (storage_data_key && !info.url) {
                        data = this.get_stored_data(storage_data_key);
                    }
                    this.cache_data(storage_data_key, data);







                }

            }

            this.fireEvent('new_data_arrival', data);
            Object.each(this.stored_request, function (request) {
                request.fireEvent('new_data_arrival', data);
            });
            if (!data.has_payload()) {
                var timestamp = data.get_timestamp_epoch();
                var dataset = data.get_dataset();
                var vars = data.get_variables_with_units();
                if (timestamp && dataset && vars.length) {
                    data_key = this.make_data_key({'dataset': dataset, 'grid': data.is_gridded(), variables: vars, timestamp: timestamp});
                    if (!this.is_requested(data_key)) {
                        this.make_data_request(data_key);
                        this.event_to_request.register(data_key, false);
                    }
                }
            }
        },
        worker_message: function (evt) {
            this.fireEvent('worker_message', evt);
        },
        process_request: function (request) {
            this.fireEvent('process_request', request);
        },

        /*
         * Actions
         */
        make_dates_request: function (request) {
            this.send_data_worker_message({'cmd': 'get_dates', 'options': request.metadata()});
        },
        make_data_key: function (metadata) {
            var util = OCS.Viewer.Functions.get_utilities();
            var vars = [];
            metadata.variables.each(function (variable) {
                if (variable.parm !== "stid") {
                    vars.push({parm: variable.parm, units: variable.units});
                }
            });
            metadata.variables = vars;

            return util.make_data_request_category_key(metadata, {'dataset': "String", 'grid': "Boolean", 'variables': "JSON", timestamp: "Integer"});
        },
        unmake_data_key: function (string) {
            var util = OCS.Viewer.Functions.get_utilities();
            return util.unmake_data_request_category_key(string);
        },
        make_data_request: function (in_req_options) {
            var util = OCS.Viewer.Functions.get_utilities();
            var req_options = in_req_options;
            if (util.is_string(in_req_options)) {
                req_options = this.unmake_data_key(req_options);
            }
            var dateObj = OCS.Functions.get_OCSDateTime();
            req_options.timestamp_epoch = req_options.timestamp;
            req_options.timestamp = dateObj.get_utc_string_with_format(req_options.timestamp, dateObj.options.long_time_format);

            if (!req_options.dataset || !OCS.Datasets[req_options.dataset]) {
                return false;
            }
            switch (OCS.Datasets[req_options.dataset].get_datatype()) {
                case "nids":
                    //radar
                    console.log("DataManager: radar request", in_req_options);
                    this.make_radar_request(req_options);
                    break;
                case "netcdf":
                    var reqs = OCS.Viewer.Functions.get_utilities().array_split_by_object_prop(req_options.variables, ['parm', 'units']);
                    var url_ops = {
                        dataset: "dataset/" + req_options.dataset,
                        var : "var/" + reqs.parm.join(','),
                        units: "units/" + reqs.units.join(','),
                        date: "date/" + req_options.timestamp
                    };
                    if (req_options.grid) {
                        url_ops.grid = OCS.Datasets[req_options.dataset].get_gridded_url();
                    }
                    req_options.url = OCS.Datasets[req_options.dataset].get_url(url_ops);
                    /* falls through */
                default:
                    this.send_data_worker_message({'cmd': 'get_data', 'options': req_options});
                    break;
            }

        },
        make_radar_request: function (req_options) {
            // create the dataurl to retrieve radar data
            if (!this.options.actively_retrieve_data) {
                return;
            }
            var dateObj = OCS.Functions.get_OCSDateTime();
            var dataset = OCS.Datasets[req_options.dataset];
            var options = {
                year: dateObj.get_utc_string_with_format(req_options.timestamp_epoch, dateObj.options.year_format),
                month: dateObj.get_utc_string_with_format(req_options.timestamp_epoch, dateObj.options.month_format),
                day: dateObj.get_utc_string_with_format(req_options.timestamp_epoch, dateObj.options.day_format),
                formatdate: dateObj.get_utc_string_with_format(req_options.timestamp_epoch, dateObj.options.YmdHM_time_format),
                radar_id: req_options.variables[0].units,
                product: req_options.variables[0].parm
            };
            var dataURL = dataset.get_url(options);

            //send the request to get the binary radar data

            var req = this.request_manager.request(dataURL, {'method': "get", 'url': dataURL, 'responseType': 'arraybuffer', passthrough_ops: req_options});
            req.addEvent('success', this.radar_request_success.bind(this));
            req.send();
        },
        radar_request_success: function (response) {
            var metadata = response.request.get_passthrough_ops();
            var options = {
                arraybuffer: response.arraybuffer,
                json: {dataset: metadata.dataset, info: {product: metadata.variables[0].parm, radarid: metadata.variables[0].units, timestamp: metadata.timestamp_epoch}, payload: true}
            };
            try {

                // Bypass worker if browser is IE - IE doesn't support shared data objects,
                // so the overhead of using the worker is as bad as doing the processing in
                // the foreground.
                if (OCS.Viewer.Functions.use_workers() && this.options.webworker_radar_parser) {
                    // Get the worker manager and add the potential worker to its queue. 
                    var wm = OCS.Functions.get_worker_manager();
                    var path = OCS.Package.root + "workers/radar_worker.js";
                    wm.make_request({
                        'msg_queue': [{
                                'cmd': 'init',
                                'options': {'class': "NexradLevel3ParserWorker"}
                            }, {'cmd': 'nexrad_parse', 'options': options}],
                        'path': path,
                        'data_callback': this.radar_worker_message.bind(this)
                    });
                } else {
                    var nexrad = new OCS.Parsers.Classes.NexradLevel3(options.arraybuffer, options.json);
                    if (nexrad.parse() > 0) {
                        response = OCS.Functions.define_data_obj({entry: {json: nexrad.parsed}});
                        this.new_data_arrival(response);
                    }
                }
                /* istanbul ignore next */
            } catch (err) {
                console.warn("data_manager: error parsing radar: " + err);
            }
        },
        radar_worker_message: function (evt) {
            var response_data = OCS.Functions.define_data_obj({
                entry: {json: evt.options.result}
            });
            this.new_data_arrival(response_data);
        },

        help: function () {
            if (this.options.debug) {
                console.log("Here are some common function to remember.");
                console.log("set_debug: function(val)");
                console.log("send_data_worker_message: function (msg) where msg is in the form {'cmd': 'set_debug', 'options': 'val'}");
                console.log("Example 1: send_data_worker_message({'cmd': 'set_actively_retrieve_data', 'options': true)};");
                console.log("Example 2: send_data_worker_message({'cmd': 'start')};");
            }
        },

        /*
         * Boolean methods
         */
        is_requested: function (string) {
            var requested_files = this.event_to_request.get_active_keys();
            if (requested_files.contains(string)) {
                // Simple, it contains it, no further test required
                return string;
            }

            //,{"parm":"stid","units":"nada"} 
            var req_obj = this.unmake_data_key(string);

            // Lets try remaking the key
            var test_str = this.make_data_key(req_obj);
            if (test_str !== string && requested_files.contains(test_str)) {
                return test_str;
            }

            return false;
        },

        /*
         * Get / Set Methods
         */
        retrieve_data_request: function (dataset, variables, gridded) {
            var keys = Object.keys(this.stored_request);
            var request, i, req_dataset, req_gridded;
            var found_request = [];
            for (i = 0; i < keys.length; i++) {
                request = this.stored_request[keys[i]];
                req_dataset = request.get_dataset();
                req_gridded = request.is_gridded();
                if (req_dataset === dataset && req_gridded === gridded && request.has_variables_with_units(variables)) {
                    found_request.push(request);
                }
            }
            return found_request;
        },
        set_debug: function (val) {
            this.parent(val);
            this.send_data_worker_message({'cmd': 'set_debug', 'options': val});

        },

        /*
         * Interface methods
         */
        send_data_worker_message: function (data) {
            // To be overrided by interface
        },
        start_data_worker: function () {
            // To be overrided by interface
        },
        stop_data_worker: function () {
            // To be overrided by interface
        },

        destroy: function () {
            if (this.options.debug) {
                console.debug('Data Manager: Destroying!');
            }
            if (this.stop_data_worker) {
                this.stop_data_worker();
            }
            if (this.data_store_destroy) {
                this.data_store_destroy();
            }

            if (this.dataworker_activation_timeout) {
                clearTimeout(this.dataworker_activation_timeout);
                this.dataworker_activation_timeout = null;
            }
            this.removeEvents();
            var sm = OCS.Viewer.Functions.get_storage_manager();
            sm.removeEvent(sm.options.data_expiration_event, this.bound_methods.on_data_expiration);
            this.bound_methods = {};
            this.destroy_manager();
        },

    });
    OCS.Viewer.Classes.DataManager.implement(OCS.Viewer.Interfaces.DataStore);
    OCS.Viewer.Classes.DataManager.implement(OCS.Viewer.Interfaces.DataWorker);
    OCS.Viewer.Functions.get_data_manager = function (ops) {
        if (!OCS.Viewer.Live.DataManager) {
            new OCS.Viewer.Classes.DataManager(ops);
        }
        return OCS.Viewer.Live.DataManager;
    };
};
OCS.Viewer.Functions.define_data_manager();



